import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

window.addEventListener('error', e => {
  if (e.message === 'ResizeObserver loop limit exceeded') {
      const resizeObserverErrDiv = document.getElementById(
          'webpack-dev-server-client-overlay-div'
      );
      const resizeObserverErr = document.getElementById(
          'webpack-dev-server-client-overlay'
      );
      if (resizeObserverErr) {
          resizeObserverErr.setAttribute('style', 'display: none');
      }
      if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute('style', 'display: none');
      }
  }
});
ReactDOM.render(
    <App />,
 document.getElementById('root'));